import { action, makeObservable, observable, persist } from '~/modules';

export default class UtilsStore {
  @persist('object')
  @observable
  currentProgressId = 1;

  constructor() {
    makeObservable(this);
  }

  @action
  setProgressId = async (id: number): Promise<void> => {
    this.currentProgressId = id;
  };
}
